import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import style from './PromoMessage.module.scss';

const PromoMessage = forwardRef((props, ref) => {
  const { text, promotionColour, className } = props;

  const colorVariants = {
    red: style.redText,
    green: style.greenText,
    redBackground: style.redBackground,
    greenBackground: style.greenBackground,
  };

  return (
    <div
      className={`${style.container} ${colorVariants[promotionColour]} ${className}`}
      ref={ref}
    >
      <div
        className={`${style.background} ${
          colorVariants[`${promotionColour}Background`]
        }`}
      />
      <span>{text}</span>
    </div>
  );
});

PromoMessage.propTypes = {
  text: PropTypes.string,
  promotionColour: PropTypes.string,
};

PromoMessage.defaultProps = {
  text: '',
  promotionColour: 'red',
};

export default PromoMessage;
